module.exports = __webpack_public_path__ + "img/Allen Bradley.4da118ac.png";